/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import { BsCheckCircleFill } from "react-icons/bs";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Vision UI Dashboard Materail-UI example components
import Table from "examples/Tables/Table";

// Moralis
import { useMoralis } from "react-moralis";
import VuiButton from "components/VuiButton";

function Transactions() {
  const { Moralis } = useMoralis();
  const [transactions, setTransactions] = useState([]);

  const fetchTransactions = async () => {
    const response = await getTransactions();
    setTransactions(response);
  };

  const columns = [
    { name: "wallet", align: "center" },
    { name: "members", align: "center" },
    { name: "email", align: "center" },
    { name: "txHash", align: "center" },
  ];

  const getTransactions = async () => {
    try{
      const Transaction = Moralis.Object.extend("Transaction");
      const query = new Moralis.Query(Transaction);
      const results = await query.find();
      return results.map(elem => (
        {
          wallet: (
            <VuiBox display="flex" py={1}>
              {elem.attributes.customerWalletAddress.slice(0,10)}...
            </VuiBox>
          ),
          members: (
            <VuiTypography variant="button" color="white" fontWeight="bold">
              {elem.attributes.userTelegram}
            </VuiTypography>
          ),
          email: (
            <VuiBox display="flex" py={1}>
              {elem.attributes.email}
            </VuiBox>
          ),
          txHash: (
            <a href={elem.attributes.transactionHash} target="_blank">
              <VuiTypography variant="button" color="white" fontWeight="bold">
                {elem.attributes.transactionHash}
              </VuiTypography>
            </a>
          ),
        }
      ))
    } 
    catch(err) {
      return Promise.reject(err);
    }
  }
 
  return (
    <Card
      sx={{
        height: "100% !important",
      }}
    >
      <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="32px">
        <VuiBox mb="auto">
          <VuiTypography color="white" variant="lg" mb="6px" gutterBottom>
            Transactions
          </VuiTypography>
          <VuiBox display="flex" alignItems="center" lineHeight={0}>
            <BsCheckCircleFill color="green" size="15px" />
            <VuiTypography variant="button" fontWeight="regular" color="text" ml="5px">
              &nbsp;<strong>{transactions.length} members</strong> this month
            </VuiTypography>
          </VuiBox>
        </VuiBox>
        <VuiBox>
            <VuiButton variant="gradient" color="light" onClick={fetchTransactions}>Show Transactions</VuiButton>
          </VuiBox>
      </VuiBox>
      <VuiBox
        sx={{
          "& th": {
            borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
              `${borderWidth[1]} solid ${grey[700]}`,
          },
          "& .MuiTableRow-root:not(:last-child)": {
            "& td": {
              borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                `${borderWidth[1]} solid ${grey[700]}`,
            },
          },
        }}
      >
        <Table columns={columns} rows={transactions} />
      </VuiBox>
    </Card>
  );
}

export default Transactions;
